// extracted by mini-css-extract-plugin
module.exports = {"message":"message_message__6i_FH","buttonContainer":"message_buttonContainer__14hXi"};